import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry, SentryErrorBoundary } from './lib/sentry'

// Sentry first — it needs to install its instrumentation before React
// mounts so unhandled errors during the initial render are captured.
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ resetError }) => (
        <div className="min-h-screen flex items-center justify-center bg-cream p-6" dir="ltr">
          <div className="max-w-md w-full bg-white rounded-2xl border border-line p-6 text-center shadow-lg">
            <div className="w-14 h-14 mx-auto rounded-full bg-red-50 text-red-500 flex items-center justify-center mb-4">
              <i className="ri-error-warning-line text-2xl"></i>
            </div>
            <h1 className="text-lg font-bold text-ink mb-2">Something went wrong</h1>
            <p className="text-sm text-muted mb-5">
              Our team has been notified. You can try again or reload the page.
            </p>
            <div className="flex items-center justify-center gap-2">
              <button
                onClick={resetError}
                className="px-4 py-2 rounded-xl border border-line-strong bg-white text-sm font-semibold text-ink-soft hover:bg-cream cursor-pointer"
              >Try again</button>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-xl bg-gold text-ink text-sm font-semibold hover:bg-gold-dark cursor-pointer"
              >Reload</button>
            </div>
          </div>
        </div>
      )}
    >
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
)
